// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "工程伦理",
      "tec": "毛云秀王若曦",
      "week": "1-8周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "有机化学",
      "tec": "郝文峰",
      "week": "1-12周",
      "add": "教学楼D座122新能"
    },
    {
      "sub": "化工原理",
      "tec": "李英杰",
      "week": "1-11周",
      "add": "教学楼D座122新能"
    },
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "电厂水质分析",
      "tec": "刘瑾",
      "week": "1-11周",
      "add": "教学楼D座122新能"
    },
    {
      "sub": "仪器分析",
      "tec": "唐坚",
      "week": "1-11周",
      "add": "教学楼D座122新能"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "化工原理",
      "tec": "李英杰",
      "week": "1-11周",
      "add": "教学楼D座122新能"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼B座425能动"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-12周",
        "add": "教学楼B座425能动"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电厂水质分析",
      "tec": "刘瑾",
      "week": "1,3,5,7,9周",
      "add": "教学楼D座122新能"
    },
    [
      {
        "sub": "仪器分析",
        "tec": "唐坚",
        "week": "1,3,5,7,9周",
        "add": "教学楼D座122新能"
      },
      {
        "sub": "有机化学",
        "tec": "郝文峰",
        "week": "2,4,6,8,10周",
        "add": "教学楼D座122新能"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "赵明明李瀚林",
      "week": "1-5周",
      "add": "教学楼D座124新能"
    },
    0,
    0
  ],
  "5": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼A座117电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-12周",
        "add": "教学楼A座117电力"
      }
    ],
    {
      "sub": "有机化学",
      "tec": "郝文峰",
      "week": "1-11周",
      "add": "教学楼D座122新能"
    },
    {
      "sub": "化工原理",
      "tec": "李英杰",
      "week": "1-10周",
      "add": "教学楼D座122新能"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
